export default "__VITE_ASSET__BV48$mkm__"